import React from "react";

const DropdownSelect = ({
  label,
  icon,
  selectedValue,
  options = [],
  onChange,
  isOpen,
  onToggle,
  dropdownRef,
  minWidth = "0",
  style = {},
  placeholder
}) => {
  const selectedOption = options.find((opt) => opt.value === selectedValue) || { label: placeholder || `All ${label}s` };

  return (
    <div className="position-relative" ref={dropdownRef} style={style}>
      <button
        type="button"
        onClick={onToggle}
        className="btn btn-light bg-white border border-secondary-soft text-dark-75 font-weight-bold px-4 py-2 d-flex flex-column align-items-start justify-content-center rounded-lg shadow-sm w-100"
        style={{
          width: "100%",
          minWidth: minWidth === "100%" ? 0 : minWidth,
          maxWidth: "100%",
          minHeight: "55px",
          height: "100%",
          border: "1px solid #E4E6EF",
          transition: "all 0.2s ease",
          whiteSpace: "normal"
        }}
      >
        <span style={{ fontSize: "0.75rem", color: "#5E6278", fontWeight: 600, marginBottom: 2 }}>
          {label}
        </span>
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
            {icon && <span className="mr-3 d-flex align-items-center" style={{ flexShrink: 0 }}>{icon}</span>}
            <span className="font-size-base text-dark-75 font-weight-bolder text-left" style={{ fontSize: "0.95rem", wordBreak: "break-word" }}>
              {selectedOption.label}
            </span>
          </div>
          <svg
            className="text-muted ml-3"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
              flexShrink: 0
            }}
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </button>

      {isOpen && (
        <div
          className="position-absolute bg-white rounded-lg shadow-lg border border-light py-2 mt-2 analytics-dropdown-menu"
          style={{
            right: "0",
            top: "100%",
            minWidth: "100%",
            width: "max-content",
            zIndex: 1050,
            boxShadow: "0px 10px 30px rgba(82, 63, 105, 0.08)",
            maxHeight: options.length > 4 ? "230px" : "none",
            overflowY: options.length > 4 ? "auto" : "hidden",
            scrollbarWidth: "thin",
            scrollbarColor: "#6f42c1 transparent",
          }}
        >
          {options.map((opt) => {
            const isActive = opt.value === selectedValue;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => {
                  onChange(opt.value);
                  onToggle();
                }}
                className={`dropdown-item d-flex align-items-center justify-content-between px-5 py-3 text-left w-100 border-0 ${isActive ? "bg-light-primary text-primary font-weight-bolder" : "text-dark-75 font-weight-bold"
                  }`}
                style={{
                  fontSize: "0.92rem",
                  transition: "all 0.15s ease",
                  backgroundColor: isActive ? "#F3F0FD" : "transparent",
                  color: isActive ? "#6f42c1" : "#3F4254",
                  whiteSpace: "nowrap"
                }}
              >
                <span>{opt.label}</span>
                {isActive && (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#6f42c1"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default React.memo(DropdownSelect);
